import { render, staticRenderFns } from "./LoginLogDetail.vue?vue&type=template&id=2387d1b8"
import script from "./LoginLogDetail.vue?vue&type=script&lang=ts"
export * from "./LoginLogDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports